import moment from "moment/moment";

export const EXAM_CONSTANTS = {
    "1M": {
        smstCd: 1,
        smstNm: "1학기",
        examName: "중간고사",
    },
    "1F": {
        smstCd: 1,
        smstNm: "1학기",
        examName: "기말고사",
    },
    "2M": {
        smstCd: 2,
        smstNm: "2학기",
        examName: "중간고사",
    },
    "2F": {
        smstCd: 2,
        smstNm: "2학기",
        examName: "기말고사",
    },
};

/** 비로그인 직접 진입(MMBR_SEQ 링크)에서 GRAD_CD 가 없을 때 사용할 기본 학년 (탭으로 바꿀 수 있다) */
export const DEFAULT_GRAD_CD = "GR21";

/** 마이페이지 학년 코드 정규화 (예비중 GR20 -> 중1, 졸업 GR30 -> 중3) */
export const NORMALIZE_GRAD_CD = (gradCd) => {
    if (gradCd === "GR30") return "GR23";
    if (gradCd === "GR20") return "GR21";
    return gradCd;
};

/** 시험대비모드 미션 정보(SMST_CD + EXAM_DVSN_CD_1)를 시험 구분 코드(1M/1F/2M/2F)로 변환 */
export const toExamDvsnCd = (missPlanInfo) => {
    const examType = { EX10: "M", EX20: "F" }[missPlanInfo?.EXAM_DVSN_CD_1];
    return missPlanInfo?.SMST_CD && examType ? `${missPlanInfo.SMST_CD}${examType}` : "";
};

export const GRAD_TO_NUMBER = {
    GR21: 1,
    GR22: 2,
    GR23: 3,
};

export const EXAM_SUBJECTS_KR = ["국어", "영어", "수학", "사회", "역사", "과학", "제2외국어"];

export const EXAM_SUBJECTS_EN = ["KORN", "ENGM", "MATH", "SOSI", "HIST", "SCNE", "FLNG"];

export const convertDateWithDay = (dateStr) => {
    return moment(dateStr, "YYYYMMDD").format("YYYY.MM.DD(ddd)");
};

export const convertDateToHypen = (dateStr) => {
    if (dateStr === "") return dateStr;
    return moment(dateStr, "YYYYMMDD").format("YYYY-MM-DD");
};

export const formatDateString = (dateStr) => {
    return dateStr.replace(/-/g, "");
};

export const scoreAverage = (scores) => {
    const scoresArr = Object.values(scores);

    const avg =
        scoresArr.reduce((sum, score) => {
            if (score !== undefined && score !== null) {
                return sum + Number(score);
            }
            return sum;
        }, 0) / scoresArr.filter((data) => data !== undefined && data !== null).length;

    if (isNaN(avg)) {
        return "-";
    }
    return Number(avg.toFixed(1));
};

export const initExamInfo = (EXAM_LIST, SCORE_LIST) => {
    const examInfo = {};

    Object.keys(EXAM_CONSTANTS).forEach((code) => [
        (examInfo[code] = {
            EXAM_DVSN_CD: code,
            EXAM_START_DT: "",
            EXAM_END_DT: "",
            EXAM_VLTN_YN: "Y",
            PLAN_DSP_YN: "Y",
            SCORES: {
                KORN: undefined,
                ENGM: undefined,
                MATH: undefined,
                SOSI: undefined,
                HIST: undefined,
                SCNE: undefined,
                FLNG: undefined,
            },
            AVERAGE: "-",
        }),
    ]);

    EXAM_LIST.forEach(({ EXAM_DVSN_CD, EXAM_START_DT, EXAM_END_DT, EXAM_VLTN_YN, PLAN_DSP_YN }) => {
        examInfo[EXAM_DVSN_CD] = {
            ...examInfo[EXAM_DVSN_CD],
            EXAM_DVSN_CD,
            EXAM_START_DT,
            EXAM_END_DT,
            EXAM_VLTN_YN,
            PLAN_DSP_YN,
        };
    });

    SCORE_LIST.forEach(({ EXAM_COURSE_CODE, EXAM_DVSN_CD, SCORE }) => {
        const current = examInfo[EXAM_DVSN_CD];

        const scores = {
            ...current.SCORES,
            [EXAM_COURSE_CODE]: SCORE,
        };

        examInfo[EXAM_DVSN_CD] = {
            ...current,
            SCORES: scores,
            AVERAGE: scoreAverage(scores),
        };
    });

    return examInfo;
};
